import type { SandboxEnvironment } from '@vy/types';
import { SANDBOX_ENVIRONMENTS } from '@vy/types';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { SandboxEnvironmentBar } from '../components/utility/SandboxEnvironmentBar';
import { withSuspenseBoundary } from '../components/utility/SuspenseBoundary';
import { useSandboxUser } from '../hooks/requests/use-sandbox-user';
import { isLoggedIn } from '../services/user-auth';
import { isSandboxEnvironment } from '../utils/env-indicator';

const ProtectedRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();

  const [sandboxEnvironment, setSandboxEnvironment] = useState<SandboxEnvironment>(
    SANDBOX_ENVIRONMENTS.AI_DATA,
  );
  useSandboxUser(sandboxEnvironment, {
    cacheTime: 0,
    staleTime: 0,
    suspense: true,
  });

  return isLoggedIn() ? (
    <>
      {isSandboxEnvironment() && (
        <SandboxEnvironmentBar onChange={(newEnvironment) => setSandboxEnvironment(newEnvironment)} />
      )}

      <div className={twMerge(isSandboxEnvironment() ? 'pt-[52px]' : 'pt-0', 'h-full')}>{children}</div>
    </>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export const ProtectedRouteWithSuspenseBoundary = withSuspenseBoundary(ProtectedRoute);
export { ProtectedRouteWithSuspenseBoundary as ProtectedRoute };
